import env from '@config/env';
import axios from 'axios';

/** Default timeout for JSON API calls. */
export const REQUEST_TIMEOUT_MS = 30_000;

/** Timeout for file/video uploads (50 MB+). */
export const UPLOAD_TIMEOUT_MS = 2 * 60 * 1000;

const normalizeBaseUrl = (value) => {
  const trimmed = String(value || '').trim();
  if (!trimmed || trimmed === 'undefined' || trimmed === 'null' || trimmed === 'invalid') {
    return 'http://localhost:8000/api/v1';
  }
  return trimmed.replace(/\/$/, '');
};

const axiosInstance = axios.create({
  baseURL: normalizeBaseUrl(env.API_BASE_URL),
  timeout: REQUEST_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export default axiosInstance;
